import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// common components
import FontIcon from './../../../common/FontIcon/FontIcon';
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
// css
import './UserTestList.scss';
import ModuleList from '../../CourseModule/ModuleList/ModuleList';
// import FeedbackForm from '../../../common/FeedbackForm/FeedbackForm';

const UserTestList = ({ details, takeTestPage, salesFeedbackList }) => {

	const present_date = new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-"+new Date().getDate();
	const present_time = new Date().getHours()+":"+new Date().getMinutes()+":"+new Date().getSeconds();
	const present_date_time = present_date + " " + present_time;
	const e_date = new Date(details.batch_expiry_date);
	const f_date = new Date(e_date.getTime()); e_date.setMinutes(e_date.getMinutes() + 330);
	const expiry_date = moment(e_date).format('YYYY-MM-DD 23:59:59');
	const start = moment(present_date_time);
	const end = moment(expiry_date);
	const diff = end.diff(start,"days");
	const display_date = start>end?true:false;

	// if(details.count===0 && details && details.modules && details.modules.length > 0){
	// 	return(
	// 		<div>
	// 			<FeedbackForm 
	// 				salesFeedbackList={salesFeedbackList}
	// 				courseName={details.course_name}
	// 				startDate={details.start_date} 
	// 				endDate={details.end_date}
	// 				userId={details.user_id}
	// 				courseId={details.course_id}/>
	// 		</div>
	// 	);
	// }

	if (details && details.modules && details.modules.length > 0) {
		return (
			<div>	
				{(!display_date)&&(diff>=0 && diff<=60)&&
				<div className="expirydate-notification">Course is available till {moment(expiry_date).format('Do MMMM YYYY')}&nbsp;<b>({diff} Days left)</b></div>}
				{display_date&&<div className="expiry-notification"><b>Course has been expired on {moment(expiry_date).format('Do MMMM YYYY')}</b></div>}
			<div className='row UserTestList'>
				{details.modules.map((item,index) => (
					<div className='col-sm-5 col-md-3' key={item.module_id}>
						<div className='test-card'>
							<div>								
								<div className='heading'>							
                                    <span className="dot">{index+1}</span>
									<span className="modulename">{item.module_name}</span>
								</div>								 
								  {item.user_attempts.length > 0 && item.user_attempts.map((score, i) => {
									if (score.testStatus === 'C') {
										return (
											<div className='test-score' key={i}>
												<div className='time'>
													<FontIcon iconName='calender' />
													<span>{moment(score.completion_date).format('DD MMM YYYY')}</span>
												</div>
												{(parseInt(score.result)< 90)?
												<div className='score-red'>{score.result}</div>:
												<div className='score-green'>{score.result}</div> }
											</div>
										);
									}
									if (score.testStatus === 'I') {
										return (
											<div className='test-score' key={i}>
												<div className='time'><b>
													<FontIcon iconName='calender' />
													</b>
													<span>{moment(score.created_date).format('DD MMM YYYY')}</span>
												</div>
												<div className='score'>In Progress</div>
											</div>
										);
									}
									return null;
								})}
								{item.user_attempts && item.user_attempts.every(val => val.testStatus === 'N') &&
									<div className='loader-msg'>Take a test to see the score</div>}
							</div>
							<div className='action'>
								<CustomButton
									name={
										item.user_attempts && item.user_attempts.some(val => val.testStatus === 'I') ?
										'Continue' : 'Take Test'
									}
									disabled={ display_date ||
										(item.user_attempts && item.user_attempts.length > 0 && item.user_attempts.every(val => val.complete === 'Y'))||
										(item.user_attempts.some(val=>(val.attempt===3)&&(parseInt(val.result)>=90))||
										item.user_attempts.some(val=>(val.attempt===4)&&(parseInt(val.result)>=90)))}
									onClick={() => takeTestPage(details.user_id, item.module_id, item.user_attempts)}
								/>
							</div>
						</div>
					</div>
				))}
			</div>
			</div>
		);
	}
	return (<Loader />);
}


UserTestList.propTypes = {
	history: PropTypes.instanceOf(Object),
	details: PropTypes.instanceOf(Object),
	takeTestPage: PropTypes.func
};

UserTestList.defaultProps = {
	history: {},
	details: {},
	takeTestPage: () => { }
};

export default UserTestList;



// WEBPACK FOOTER //
// ./components/Dashboard/UserTestList/UserTestList.js